/* ============================================================================
   WWF-CUSTOM FILE | CL-064 | Added 2026-10-18 | Wild + Well-Fed rebrand
   ----------------------------------------------------------------------------
   Product page buy box helpers (OPEN-085, OPEN-087). Loaded from
   snippets/wwf-head.liquid (CL-064 marker); styles are in the same block.

   1. Star rating under the product title: reads the score and review count
      from the MAG reviews widget further down the page and shows
      "5.0 (5 reviews)" under the title. Tapping it scrolls to the reviews.
      Shows nothing when the product has no reviews.
   2. Sticky Add to Cart on phones: Palo Alto's cart bar (cart-bar) only
      appears after the whole product column has scrolled away, which on a
      phone is several screens. Here, on screens under 768px, the bar shows
      whenever the main Add to Cart button is off screen, and hides when the
      button is visible. The bar submits the main product form, so the
      size and Subscribe & Save choices are kept.
   3. One trust line under the main Add to Cart button: lab tested, ships
      from Bend, Oregon, and a link to the shipping and returns policy.
   ========================================================================= */
(function () {
  'use strict';

  var TRUST_HTML = 'Lab tested <span aria-hidden="true">&middot;</span> Ships from Bend, Oregon <span aria-hidden="true">&middot;</span> <a href="/policies/refund-policy">Shipping &amp; returns</a>';

  /* The visible main Add to Cart button (Palo Alto renders a hidden copy too;
     the cart bar and Quick view have their own). */
  function mainButton() {
    var btns = document.querySelectorAll('[data-add-to-cart]');
    for (var i = 0; i < btns.length; i++) {
      var b = btns[i];
      if (b.closest('cart-bar') || b.closest('.popup-quick-view__wrapper') || b.closest('[data-quickbuy-form]')) continue;
      if (b.offsetHeight > 0) return b;
    }
    return null;
  }

  /* 1. Stars under the title */
  function addStars() {
    if (document.querySelector('[data-wwf-pdp-stars]')) return true;
    var title = document.querySelector('.product__block--title');
    var widget = document.querySelector('.mag-product-review-widget');
    if (!title || !widget) return false;
    var scoreEl = widget.querySelector('.mag-overoll-count');
    var countEl = widget.querySelector('.mag-review-count');
    if (!scoreEl || !countEl) return false;
    var score = parseFloat(scoreEl.textContent);
    var count = parseInt(countEl.textContent, 10);
    if (!count || !score) return true; // no reviews: nothing to show
    var a = document.createElement('a');
    a.href = '#mag-product-review-widget';
    a.className = 'wwf-pdp-stars';
    a.setAttribute('data-wwf-pdp-stars', '');
    var full = Math.round(score);
    var stars = '';
    for (var i = 1; i <= 5; i++) stars += i <= full ? '★' : '☆';
    a.innerHTML = '<span class="wwf-pdp-stars__icons" aria-hidden="true">' + stars + '</span>' +
      '<span class="wwf-pdp-stars__text">' + score.toFixed(1) + ' (' + count + (count === 1 ? ' review' : ' reviews') + ')</span>';
    a.setAttribute('aria-label', 'Rated ' + score.toFixed(1) + ' out of 5 from ' + count + ' reviews. Go to reviews');
    a.addEventListener('click', function (e) {
      e.preventDefault();
      widget.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    title.parentNode.insertBefore(a, title.nextSibling);
    return true;
  }

  /* 3. Trust line under the main Add to Cart */
  function addTrust() {
    if (document.querySelector('[data-wwf-pdp-trust]')) return true;
    var btn = mainButton();
    if (!btn) return false;
    var holder = btn.closest('.product__submit__buttons') || btn.parentNode;
    var p = document.createElement('p');
    p.className = 'wwf-pdp-trust';
    p.setAttribute('data-wwf-pdp-trust', '');
    p.innerHTML = TRUST_HTML;
    holder.parentNode.insertBefore(p, holder.nextSibling);
    return true;
  }

  /* 2. Sticky Add to Cart on phones */
  var barStarted = false;
  function startBar() {
    if (barStarted) return true;
    var bar = document.querySelector('cart-bar');
    var btn = mainButton();
    if (!bar || !btn) return false;
    barStarted = true;
    var phone = window.matchMedia('(max-width: 767px)');
    var ticking = false;
    function apply() {
      ticking = false;
      var current = mainButton() || btn; // the theme can swap which copy is visible
      var r = current.getBoundingClientRect();
      var offScreen = r.height > 0 && (r.bottom < 0 || r.top > window.innerHeight);
      bar.classList.toggle('wwf-bar-on', phone.matches && offScreen);
    }
    function queue() { if (!ticking) { ticking = true; setTimeout(apply, 60); } }
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    apply();
    return true;
  }

  function run() {
    var done = addStars() & addTrust() & startBar();
    return !!done;
  }

  if (!document.body || !document.body.classList.contains('template-product')) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        if (document.body.classList.contains('template-product')) watch();
      });
    }
    return;
  }
  watch();

  function watch() {
    if (run()) return;
    var tries = 0;
    var obs = new MutationObserver(function () {
      tries++;
      if (run() || tries > 400) obs.disconnect();
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { obs.disconnect(); }, 20000);
  }
})();
